// removed by extract-text-webpack-plugin
module.exports = {"details":"src-__global-module___details","flightsFooter":"src-__global-module___flightsFooter","airlineLogo":"src-__global-module___airlineLogo","button":"src-__global-module___button","disabled":"src-__global-module___disabled","surfair":"src-__global-module___surfair","jetsuite":"src-__global-module___jetsuite","confirm":"src-__global-module___confirm","price":"src-__global-module___price"};


//////////////////
// WEBPACK FOOTER
// ./src/global.module.css
// module id = 362
// module chunks = 0